import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isEqual } from 'lodash';
import cn from 'classnames';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import Button from 'chameleon/ui-stack/ui/base/button';
import PracticeSkillBox from 'chameleon-packages/units/components/PracticeSkillBox';
import { setMathJaxTypeset } from 'chameleon-src/utility/utils';

import './TagWithDescriptionPopover.scss';

class TagWithDescriptionPopover extends Component {
  static propTypes = {
    tags: PropTypes.array,
  };

  shouldComponentUpdate({ tags }) {
    return !isEqual(this.props.tags, tags);
  }

  renderTags(tag, index) {
    const { isSkillChip, tagClassName } = this.props;

    // In general, tags with descriptions have different values for each field, where tags
    // without descriptions have the same value for all fields. AP Insight CA Assessment/BB Quiz tags
    // are the exception in that the title and description are the same, but the label is shorter.
    const tagHasDescription =
      tag.description && tag.description.length !== tag.title.length;

    const renderTag = tagHasDescription ? (
      <PopOver
        withPortal
        onContentMount={(contentElementRef) =>
          setMathJaxTypeset(contentElementRef.current)
        }
        trigger={(buttonProps, isOpen, triggerRef) => {
          if (isSkillChip) {
            return <PracticeSkillBox label={tag.label.replace('Skill ', '')} />;
          }
          return (
            <Button
              {...buttonProps}
              isNaked
              isLink
              accessibility={{
                title: tag.accessibilityTitle,
              }}
              className={cn(tagClassName)}
              ref={triggerRef}
            >
              {tag.label}
            </Button>
          );
        }}
        key={index}
      >
        <div className="tag_description" style={{ minWidth: '15rem' }}>
          {tag.description}
        </div>
      </PopOver>
    ) : (
      <span
        className={cn(
          'label_custom_cell font-normal text-base text-gray-800',
          tagClassName,
        )}
        key={index}
      >
        {tag.label}
      </span>
    );
    return renderTag;
  }

  render() {
    const { tags } = this.props;
    return (
      <div data-test-id="tag-wrapper" className="flex flex-row flex-wrap gap-2">
        {tags && tags.map((tag, index) => this.renderTags(tag, index))}
      </div>
    );
  }
}

export default TagWithDescriptionPopover;
